<template>
  <div :class="['content-boxes', css]">
    <!-- dimensions.width > 600 ? 'py-3xl' : 'pt-2xl pb-l', -->
    <router-link
      :to="item.url"
      v-for="item in children"
      :key="item.title"
      class="content-boxes--item text-left text-gray-7"
      :class="[properties.bg || 'bg-gray-1']"
    >
      <div class="content-boxes--item--image" :style="imageStyle(item)"></div>
      <div class="content-boxes--item--content">
        <h4
          class="font-rg"
          :class="[
            properties.titleColor || 'text-gray-8',
            properties.titleSize || ''
          ]"
          v-text="item.title"
        ></h4>
        <p
          v-if="item.summary"
          class="summary mt-l"
          :class="[
            properties.textColor || 'text-gray-8',
            properties.textSize || ''
          ]"
          v-text="item.summary"
        ></p>
      </div>
    </router-link>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    children: {
      type: Array,
      required: true
    },
    css: String,
    properties: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      interval: -1,
      timeout: -1,
      avg: 50,
      min: 48,
      max: 52
    };
  },
  methods: {
    imageStyle(item) {
      if (this.isRelative(item.image)) {
        return `background-image: url(${this.$imageFolder}/${item.image})`;
      }
      return `background-image: url(${item.image})`;
    },
    isRelative(image) {
      return image.indexOf("http") < 0;
    }
  },
  computed: {
    ...mapState(["dimensions"])
  }
};
</script>

<style lang="stylus" scoped>
.content-boxes
  _flex(row, wrap, stretch, space-between)
  &:after
    content ""
    flex 0 0 33.33%
  &--item
    flex 0 0 33.33%
    &--content
      padding 30px 30px 35px
      h4
        font-size 18px
    &:nth-child(3n+2)
      border-left 20px solid #fff
      border-right 20px solid #fff
      +below(600px)
        border-left 0px solid #fff
        border-right 0px solid #fff
      // .content-boxes--item--image
      //   padding-top calc(80% + 32px)
    transition background 0.3s ease-out
    /.grid &
      margin-bottom 20px
    /.first2 &
      &:nth-child(1)
      &:nth-child(2)
        flex 0 0 48%
    &--image
      width 100%
      height 26vh
      position relative
      overflow hidden
      background-size cover
      background-repeat no-repeat
      background-position 50%
      background-color #fdfdfd
      min-height 240px
    +desktop()
      &:hover
        background blue_4
        *
          color #fff
  +below(815px)
    _flex(columns, wrap, flex-start, flex-start)
    &--item
      flex 0 0 100% !important
      &:not(:last-child)
        marg('2xl', bottom)
</style>
